module.exports = __webpack_public_path__ + "static/media/header780.16f554ca.jpg";